const isReinsuranceContextsList = contexts => contexts.length > 0 && contexts[0].$type === 'ReinsuranceContext';

export default isReinsuranceContextsList;

export const sortReinsuranceContexts = (a, b) =>
  a.companyName.localeCompare(b.companyName) ||
  a.businessAccount.localeCompare(b.businessAccount) ||
  b.insuranceYear - a.insuranceYear;
